import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';

/**
 * Logout component that handles user logout
 * This component can be accessed via /logout route and will logout the user
 */
export const Logout = () => {
  const { logout } = useAuth();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const performLogout = async () => {
      const aiGrant = searchParams.get('aiGrant');
      const loginPath = aiGrant === '1' ? '/login?aiGrant=1' : '/login';
      try {
        await logout(loginPath);
      } catch (error) {
        console.error('Logout error:', error);
        // logout() already best-effort clears + navigates; nothing else to do
      }
    };

    performLogout();
  }, [logout, searchParams]);

  return (
    <div className="flex h-screen w-full items-center justify-center">
      <div className="text-center">
        <p className="text-lg">Logging out...</p>
      </div>
    </div>
  );
};

export default Logout;
